<h4 class="title" *ngIf="formGroup">
	{{
		(formGroup?.controls.amount ? "deposit-limit-calculator.title.amount" : "deposit-limit-calculator.title.date")
			| translate
	}}
</h4>

<form
	*ngIf="formGroup"
	#formDirective="ngForm"
	[formGroup]="formGroup"
	(ngSubmit)="onSubmit(formDirective)"
	test-id="deposit-limit-calculator-form"
	data-test-id="deposit-limit-calculator-form"
>
	<div class="form-fields-container">
		<mat-form-field
			*ngIf="formGroup?.controls.amount; else dateAndTimeForm"
			class="deposit-limit-calculator-form-amount"
		>
			<input
				type="tel"
				matInput
				[placeholder]="'deposit-limit.amount' | translate: { currency: currencyCode }"
				formControlName="amount"
				obgNumeric
				test-id="deposit-limit-calculator-form-input-amount"
				data-test-id="deposit-limit-calculator-form-input-amount"
				(change)="onAmountInputChange()"
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			*ngIf="formGroup?.controls.amount"
			test-id="deposit-limit-calculator-error-amount"
			[input]="formGroup?.controls.amount"
			translationPrefix="deposit-limit-calculator.amount"
			[translationArguments]="{ max: amountMaxValidator | obgCurrency }"
		>
		</obg-common-validation-renderer>

		<ng-template #dateAndTimeForm>
			<div class="date-and-time">
				<div class="date">
					<mat-form-field (click)="onDatePickerClick()">
						<mat-label>{{ "deposit-limit-calculator.form.date" | translate }}</mat-label>
						<input
							readonly
							autocomplete="off"
							formControlName="date"
							matInput
							[matDatepicker]="picker"
							[min]="startDate"
							class="input-date"
						/>
						<mat-datepicker-toggle
							test-id="deposit-limit-calculator-form-input-date"
							data-test-id="deposit-limit-calculator-form-input-date"
							#dateToggle
							matSuffix
							[for]="picker"
						></mat-datepicker-toggle>
						<mat-datepicker (closed)="onDatePickerClosed()" touchUi #picker></mat-datepicker>
					</mat-form-field>
					<obg-common-validation-renderer
						*ngIf="formGroup?.controls.date && displayErrorsDate"
						test-id="deposit-limit-calculator-error-date"
						[input]="formGroup?.controls.date"
						translationPrefix="deposit-limit-calculator.date"
					>
					</obg-common-validation-renderer>
				</div>

				<div class="time">
					<mat-form-field (click)="onMenuClick()">
						<mat-label>{{ "deposit-limit-calculator.form.time" | translate }}</mat-label>
						<input
							test-id="deposit-limit-calculator-form-input-time"
							data-test-id="deposit-limit-calculator-form-input-time"
							class="input-time"
							readonly
							autocomplete="off"
							formControlName="time"
							matInput
							[matMenuTriggerFor]="menu"
						/>
						<span class="ico-chevron-down" matSuffix [matMenuTriggerFor]="menu"></span>
					</mat-form-field>
					<obg-common-validation-renderer
						*ngIf="formGroup?.controls.time && displayErrorsTime"
						test-id="deposit-limit-calculator-error-time"
						[input]="formGroup?.controls.time"
						translationPrefix="deposit-limit-calculator.time"
					>
					</obg-common-validation-renderer>
					<mat-menu
						#menu="matMenu"
						test-id="deposit-limit-calculator-form-menu-time"
						yPosition="below"
						(closed)="onTimeMenuClosed()"
						class="obg-m-deposit-limit-calculator-form"
					>
						<button
							*ngFor="let time of hoursOfTheDay; let i = index"
							[attr.test-id]="'deposit-limit-calculator-form-menu-time-button-' + i"
							[attr.data-test-id]="'deposit-limit-calculator-form-menu-time-button-' + i"
							(click)="onSelectTime(time)"
							mat-menu-item
						>
							{{ time }}
						</button>
					</mat-menu>
				</div>
			</div>
		</ng-template>
	</div>

	<div class="calculation-error" test-id="deposit-limit-calculator-error-calculation" *ngIf="calculationError">
		{{
			calculationError.key
				| translate
					: {
							period: calculationError.data?.period,
							amount: calculationError.data?.amount,
							max: calculationError.data?.max | obgCurrency,
					  }
		}}
	</div>

	<button
		test-id="deposit-limit-calculator-calculate"
		data-test-id="deposit-limit-calculator-calculate"
		[disabled]="formGroup?.invalid || busy || calculationError?.data?.noLimitError"
		mat-flat-button
		color="accent"
		class="calculate"
	>
		<mat-spinner *ngIf="busy; else showContent" diameter="20"></mat-spinner>
		<ng-template #showContent>
			{{ "deposit-limit-calculator.calculate" | translate }}
		</ng-template>
	</button>
</form>
